import { Col, FormInstance, Row } from 'antd';
import CloseIcon from '@mui/icons-material/Close';
import { Title } from '../../atoms';
import { AuthForm } from '../AuthForm';
import { useUpdateUserPhoneMutation } from '@vette/data-access';
import { User } from 'firebase/auth';
import { FormValues } from '../AuthForm/types';
import { message } from '@vette/frontend-utils';
import * as S from './styles';
import { useState } from 'react';

type Props = {
  settingsForm: FormInstance;
};

export const UpdatePhoneNumber: React.FC<Props> = ({ settingsForm }) => {
  const [showModal, setShowModal] = useState(false);

  const [updateUserPhone] = useUpdateUserPhoneMutation({
    async onCompleted(data) {
      if (data.updateUserPhone?.__typename === 'User') {
        message.destroy();
        return message.success('Your profile was successfully updated.');
      } else if (data.updateUserPhone?.__typename === 'ValidationError') {
        message.destroy();
        return message.error(data.updateUserPhone?.messages[0]);
      } else {
        message.error(
          'Something went wrong. Our team was notified and is intensively working on fixing the issue.'
        );
      }
    },
  });

  const onSuccess = (user: User, values: FormValues) => {
    updateUserPhone({
      variables: {
        firebaseUid: user.uid,
        phone: values.phone,
      },
    });

    settingsForm.setFields([{ name: 'phone', value: values.phone }]);
    setShowModal(false);
  };

  return (
    <>
      <S.ChangeButton
        actionType="secondary"
        size="large"
        onClick={() => setShowModal(true)}
        aria-label="change phone number"
      >
        Change number
      </S.ChangeButton>

      {showModal && (
        <S.ChangeModal visible width={605} onCancel={() => setShowModal(false)}>
          <AuthForm
            flow="changePhone"
            phoneNumberLabel="New phone number"
            onSuccess={onSuccess}
            header={
              <Row>
                <Col flex="auto">
                  <Title level={2}>Change phone number</Title>
                </Col>
                <Col flex="32px">
                  <S.CloseButton
                    size="small"
                    actionType="tertiary"
                    onClick={() => setShowModal(false)}
                  >
                    <CloseIcon />
                  </S.CloseButton>
                </Col>
              </Row>
            }
          />
        </S.ChangeModal>
      )}
    </>
  );
};
